import { useParams } from '@tanstack/react-router'
import {
  isSupportedLanguage,
  resolvePreferredLanguage,
  type SupportedLanguage,
} from './supported-languages'

export function useCurrentLang(): SupportedLanguage {
  const params = useParams({ strict: false })
  const lang = 'lang' in params ? params.lang : undefined
  return isSupportedLanguage(lang) ? lang : resolvePreferredLanguage()
}
